



















import Vue from 'vue';

import { Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
  props: {
    selected: {
      type: String,
      default: '',
    },
  },
})
export default class successEmailPreference extends Vue {
  @Watch('selected', { immediate: true, deep: true }) // eslint-disable-next-line
  selectedDefault(value: any): void {
    switch (value) {
      case 'MAX_1_PER_DAY':
        this.selectFormat = 'daily';
        break;
      case 'MAX_1_PER_WEEK':
        this.selectFormat = 'weekly';
        break;
      case 'UNSUBSCRIBE':
        this.selectFormat = 'unsubscribe';
        break;

      default:
        break;
    }
  }

  selectFormat = '';
}

